import axios from 'axios';
import store from '../store/index';

const url = process.env.VUE_APP_API_URL;


export default class DataService {
    static async register(emailObj) {
        const res = await axios.post(`${url}/register`, emailObj).catch(e => {
            if (e.response.data.name == 'ValidationError') {
                alert('One or more of your entries has too many words.');
                console.log(e.response.data);
                return
            }
            if (e.response.data.code == 11000) {
                alert('Email already registered.')
            } else {
                alert('An error occurred')
                console.log(e.response.data)
            }
        })
        if (res) {
            return res.data
        }
    }

    static async login(emailObj) {
        const res = await axios.post(`${url}/login/`, emailObj).catch(e => {
            if (e.response.data.message == "Incorrect password") {
                alert("Incorrect password")
            } else if (e.response.data.message == "Incorrect email") {
                alert("Incorrect email. User not found in database.")
            } else {
                alert('An error occurred')
                console.log(e.response.data)
            }
        })
        if (res) {
            return res.data
        }
    }

    static async saveData(dataDetails) {
        var candidateId = store.state.user._id

        const res = await axios.post(`${url}/savedata/${candidateId}`, dataDetails, 
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JSON.parse(window.localStorage['user']).token
                }
            }
        ).catch(e => {
            if (e.response.data.name == 'ValidationError') {
                alert('One or more of your entries has too many words.');
                console.log(e.response.data);
                return
            } 
            if (e.response.data.message != 'UnauthorizedError: jwt expired') {
                alert('An error occurred')
            } 
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async deleteExternal(candidateId, assessorId, assessorType) {
        var id = {
            assessorId: assessorId,
            assessorType: assessorType
        }

        const res = await axios.delete(`${url}/deleteexternal/${candidateId}`, { data: id}).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async assignExternal(assessor) {
        var candidateId = assessor.candidateId

        const res = await axios.post(`${url}/assignexternal/${candidateId}`, assessor).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async submitComments(commentDetails) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + commentDetails.token
            }
        }

        const res = await axios.post(`${url}/submitcomments`, commentDetails, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async submitAssessment(details) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + details.token
            }
        }

        const res = await axios.post(`${url}/submitassessment/${details.candidateId}`, details, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data);
        });

        if (res) {
           return(res.data)
        };
    }

    static async deleteFile(fileDetails) {
        var candidateId = store.state.user._id

        const res = await axios.delete(`${url}/deletefile/${candidateId}`, { 
            headers: {
                Authorization: `Bearer ${JSON.parse(window.localStorage['user']).token}`
            },
            data: { source: fileDetails } 
        }).catch(e => {
            if (e.response.data.message != 'UnauthorizedError: jwt expired') {
                alert('An error occurred')
            }
            console.log(e.response.data)
        })

        if (res) {
            return res.data;
        }
    }

    static async getCandidates() {
        var candidates = await axios.get(`${url}/getcandidates/`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getNonacademicCandidates() {
        var candidates = await axios.get(`${url}/getnonacademiccandidates/`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getCandidatesThatSubmitted(details) {
        var candidates = await axios.post(`${url}/getcandidatesthatsubmitted`, details).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getCandidatesForReaderOrProf() {
        var candidates = await axios.get(`${url}/getcandidates4readerorprof/`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getAssessedCandidates() {
        var candidates = await axios.get(`${url}/getassessedcandidates/`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })

        if (candidates) {
            return candidates.data
        }
    }

    static async getCandidate(id) {
        var candidate = await axios.get(`${url}/getcandidate/${id}`).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        })
        if (candidate) {
            return candidate.data
        }
    }

    static async scoreItem(scoreDetails) {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + scoreDetails.token
            }
        }

        const candidate = await axios.put(`${url}/scoreitem`, scoreDetails, config).catch(e => {
            alert('An error occurred')
            console.log(e.response.data)
        });
        if (candidate) {
            return candidate.data
        }
    }

    static async generateToken(certifier, tokenEmail) {
        const token = await axios.get(`${url}/generatetoken?certifier=${certifier}&email=${tokenEmail}`).catch(e => {
            alert('An error occured')
            console.log(e.response.data)
        });
        if (token) {
            return token.data
        }
    }

    static async generatePassword(email) {
        const res = await axios.get(`${url}/generatepassword?email=${email}`).catch(e => {
            alert('An error occured')
            console.log(e.response.data)
        });
        if (res) {
            return res.data
        }
    }

    static async sendAppraisalList(details) {
        const res = await axios.post(`${url}/sendappraisallist`, details).catch(e => {
            alert('An error occured')
            console.log(e.response.data)
        });
        if (res) {
            return res.data
        }
    }

    static isLoggedIn() {
        if (store.state.user) {
            if (store.state.user.token) {
                var payload = JSON.parse(atob(store.state.user.token.split(".")[1]))
                return (payload.exp * 1000) > Date.now()
            } 
        } else {
            return false
        }
    }
}